import React from 'react';

import ModalBoxes from '../../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../../../common/general/ButtonGroup';
import CommentSection from '../CommentSection/CommentSection';

import './AddCommentModal.scss';

export function AddCommentModal({ modalBox, snapshotData, context }) {
  return (
    <>
      <ModalBoxes.Header>Comments</ModalBoxes.Header>
      <ModalBoxes.Body>
        <CommentSection snapshotData={snapshotData} context={context} />
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            Close
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
}

AddCommentModal.size = 'w1100';
AddCommentModal.className = 'eds-add-comment-modal';
